// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4bec3637","605":"70be86d5","981":"952debaa"}[chunkId] + ".chunk.js";
};